var map = {
	"./en-GB/common.json": [
		3336,
		97
	],
	"./en-GB/cpm-client.json": [
		3337,
		96
	],
	"./en-GB/cpm-manager.json": [
		3338,
		95
	],
	"./en-GB/opac.json": [
		3339,
		94
	],
	"./es-ES/common.json": [
		3340,
		93
	],
	"./es-ES/cpm-client.json": [
		3341,
		92
	],
	"./es-ES/cpm-manager.json": [
		3342,
		91
	],
	"./fr-FR/common.json": [
		3343,
		90
	],
	"./fr-FR/cpm-client.json": [
		3344,
		89
	],
	"./fr-FR/cpm-manager.json": [
		3345,
		88
	],
	"./fr-FR/opac.json": [
		3346,
		87
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 3201;


//////////////////
// WEBPACK FOOTER
// ./assets/langs lazy ^\.\/.*$
// module id = 3201
// module chunks = 121